module.exports = __webpack_public_path__ + "static/step-2.b6bc0222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/filtering/step-2.png
// module id = 2564
// module chunks = 55036655777194